var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "blog-social-links"
  }, [_vm.$isMobile() ? _c('seu-button', {
    staticClass: "share-button",
    attrs: {
      "label": _vm.$t('common.share'),
      "button-icon-before": _vm.shareIcon
    },
    on: {
      "click": _vm.toggleSocialMediaShare
    }
  }) : !_vm.shareActive ? _c('seu-button', {
    staticClass: "share-button",
    attrs: {
      "label": _vm.$t('common.share'),
      "button-icon-before": _vm.shareIcon
    },
    on: {
      "click": function ($event) {
        _vm.shareActive = true;
      }
    }
  }) : _c('div', {
    staticClass: "share-icons-button"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": `https://www.linkedin.com/sharing/share-offsite/?url=${_vm.url}`
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/icons/square-linkedin.svg"),
      "alt": ""
    }
  })]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": `https://twitter.com/intent/tweet?url=${_vm.url}&text=${_vm.post.details.title}`
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/icons/square-twitter.svg"),
      "alt": ""
    }
  })]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": `https://www.facebook.com/sharer/sharer.php?u=${_vm.url}`
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/icons/square-facebook.svg"),
      "alt": ""
    }
  })]), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.copyURL
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/icons/link.svg"),
      "alt": ""
    }
  })])]), _vm.showSuccessNotification ? _c('div', {
    staticClass: "success-notification"
  }, [_vm._v("Link copied!")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }